import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import Stores from './pages/Stores';
import Devices from './pages/Devices';
import Users from './pages/Users';
import Schedules from './pages/Schedules';
import Campaigns from './pages/Campaigns';
import AIContent from './pages/AIContent';
import DJStudio from './pages/DJStudio';
import AuditLog from './pages/AuditLog';
import Settings from './pages/Settings';
import MusicLibrary from './pages/MusicLibrary';
import AudioEditor from './pages/AudioEditor';
import PlaylistBuilder from './pages/PlaylistBuilder';
import RotationManager from './pages/RotationManager';
import ClockBuilder from './pages/ClockBuilder';
import RulesEngine from './pages/RulesEngine';
import SchedulePage from './pages/SchedulePage';
import Automation from './pages/Automation';
import PlayerPreview from './pages/PlayerPreview';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0a0a0f' }}><div className="spinner" /></div>;
  return user ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="stores" element={<Stores />} />
        <Route path="devices" element={<Devices />} />
        <Route path="users" element={<Users />} />
        <Route path="schedules" element={<Schedules />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="ai-content" element={<AIContent />} />
        <Route path="dj-studio" element={<DJStudio />} />
        <Route path="music-library" element={<MusicLibrary />} />
        <Route path="audio-editor" element={<AudioEditor />} />
        <Route path="playlist-builder" element={<PlaylistBuilder />} />
        <Route path="rotation-manager" element={<RotationManager />} />
        <Route path="clock-builder" element={<ClockBuilder />} />
        <Route path="rules-engine" element={<RulesEngine />} />
        <Route path="schedule" element={<SchedulePage />} />
        <Route path="automation" element={<Automation />} />
        <Route path="player-preview" element={<PlayerPreview />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ style: { background: '#1a1a2e', color: '#e2e8f0', border: '1px solid #2d2d4e' }, success: { iconTheme: { primary: '#00ff88', secondary: '#0a0a0f' } }, error: { iconTheme: { primary: '#ff4444', secondary: '#0a0a0f' } } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
